enum CorrespondenceElementEnum {
    INITIAL_REQUEST = 'INITIAL_REQUEST',
    REPLY_TO_INITIAL_REQUEST = 'REPLY_TO_INITIAL_REQUEST',
    ACKNOWLEDGEMENT_OF_RECEIPT = 'ACKNOWLEDGEMENT_OF_RECEIPT',
    REQUEST_POSTAL_ADDRESS = 'REQUEST_POSTAL_ADDRESS',
    REPLY_TO_POSTAL_ADDRESS_REQUEST = 'REPLY_TO_POSTAL_ADDRESS_REQUEST',
    CLARIFICATION_REQUEST = 'CLARIFICATION_REQUEST',
    REPLY_TO_CLARIFICATION_REQUEST = 'REPLY_TO_CLARIFICATION_REQUEST',
    PROPOSAL_FOR_FAIR_SOLUTION = 'PROPOSAL_FOR_FAIR_SOLUTION',
    REPLY_TO_FAIR_SOLUTION_PROPOSAL = 'REPLY_TO_FAIR_SOLUTION_PROPOSAL',
    CLOSING_LETTER = 'CLOSING_LETTER',
    INCOMING_APPLICANT_CORRESPONDENCE = 'INCOMING_APPLICANT_CORRESPONDENCE',
    OUTGOING_APPLICANT_CORRESPONDENCE = 'OUTGOING_APPLICANT_CORRESPONDENCE',
    REPLY_TO_CONFIRMATORY_REQUEST = 'REPLY_TO_CONFIRMATORY_REQUEST',
    REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL = 'REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL',
    EXTENDED_DEADLINE_LETTER = 'EXTENDED_DEADLINE_LETTER',
    CONFIRMATORY_REQUEST = 'CONFIRMATORY_REQUEST',
    ACKNOWLEDGEMENT_OF_RECEIPT_OF_THE_INITIAL_CONFIRMATORY_REPLY = 'ACKNOWLEDGEMENT_OF_RECEIPT_OF_THE_INITIAL_CONFIRMATORY_REPLY',
    UNILATERAL_RESTRICTION_OF_THE_SCOPE = 'UNILATERAL_RESTRICTION_OF_THE_SCOPE',
    HOLDING_REPLY = 'HOLDING_REPLY'
}
namespace CorrespondenceElementEnum {

    type AdditionalFields = { resourceKey: string, dbElementKey: number, replyResourceKey: string, replyDbElementId: number };
    export type Entry = { enumKey: string } & AdditionalFields;

    const fieldsMap: Map<CorrespondenceElementEnum, AdditionalFields> = new Map(
        [
            [CorrespondenceElementEnum.INITIAL_REQUEST,
            {
                resourceKey: 'easeportal.enum.INITIAL_REQUEST', dbElementKey: 1,
                replyResourceKey: 'easeportal.enum.REPLY_TO_INITIAL_REQUEST', replyDbElementId: 2
            }],
            [CorrespondenceElementEnum.REPLY_TO_INITIAL_REQUEST,
            { resourceKey: 'easeportal.enum.REPLY_TO_INITIAL_REQUEST', dbElementKey: 2, replyResourceKey: '', replyDbElementId: 0 }],
            [CorrespondenceElementEnum.ACKNOWLEDGEMENT_OF_RECEIPT,
            {
                resourceKey: 'easeportal.enum.ACKNOWLEDGEMENT_OF_RECEIPT', dbElementKey: 3,
                replyResourceKey: 'easeportal.communication.REPLY',
                replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.REQUEST_POSTAL_ADDRESS,
            {
                resourceKey: 'easeportal.enum.REQUEST_POSTAL_ADDRESS', dbElementKey: 4,
                replyResourceKey: 'easeportal.enum.REPLY_TO_POSTAL_ADDRESS_REQUEST', replyDbElementId: 5
            }],
            [CorrespondenceElementEnum.REPLY_TO_POSTAL_ADDRESS_REQUEST,
            { resourceKey: 'easeportal.enum.REPLY_TO_POSTAL_ADDRESS_REQUEST', dbElementKey: 5, replyResourceKey: '', replyDbElementId: 0 }],
            [CorrespondenceElementEnum.CLARIFICATION_REQUEST,
            {
                resourceKey: 'easeportal.enum.CLARIFICATION_REQUEST', dbElementKey: 6,
                replyResourceKey: 'easeportal.enum.REPLY_TO_CLARIFICATION_REQUEST', replyDbElementId: 7
            }],
            [CorrespondenceElementEnum.REPLY_TO_CLARIFICATION_REQUEST,
            { resourceKey: 'easeportal.enum.REPLY_TO_CLARIFICATION_REQUEST', dbElementKey: 7, replyResourceKey: '', replyDbElementId: 0 }],
            [CorrespondenceElementEnum.PROPOSAL_FOR_FAIR_SOLUTION,
            {
                resourceKey: 'easeportal.enum.PROPOSAL_FOR_FAIR_SOLUTION', dbElementKey: 8,
                replyResourceKey: 'easeportal.enum.REPLY_TO_FAIR_SOLUTION_PROPOSAL', replyDbElementId: 9
            }],
            [CorrespondenceElementEnum.REPLY_TO_FAIR_SOLUTION_PROPOSAL,
            {
                resourceKey: 'easeportal.enum.REPLY_TO_FAIR_SOLUTION_PROPOSAL', dbElementKey: 9,
                replyResourceKey: '', replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.CLOSING_LETTER,
            { resourceKey: 'easeportal.enum.CLOSING_LETTER', dbElementKey: 15, replyResourceKey: '', replyDbElementId: 0 }],
            [CorrespondenceElementEnum.INCOMING_APPLICANT_CORRESPONDENCE,
            {
                resourceKey: 'easeportal.enum.INCOMING_APPLICANT_CORRESPONDENCE', dbElementKey: 16,
                replyResourceKey: '', replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.OUTGOING_APPLICANT_CORRESPONDENCE,
            {
                resourceKey: 'easeportal.enum.OUTGOING_APPLICANT_CORRESPONDENCE', dbElementKey: 17,
                replyResourceKey: 'easeportal.communication.REPLY', replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.REPLY_TO_CONFIRMATORY_REQUEST,
            { resourceKey: 'easeportal.enum.REPLY_TO_CONFIRMATORY_REQUEST', dbElementKey: 30, replyResourceKey: '', replyDbElementId: 0 }],
            [CorrespondenceElementEnum.REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL,
            {
                resourceKey: 'easeportal.enum.REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL', dbElementKey: 31,
                replyResourceKey: '', replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.EXTENDED_DEADLINE_LETTER,
            { resourceKey: 'easeportal.enum.EXTENDED_DEADLINE_LETTER', dbElementKey: 13, replyResourceKey: '', replyDbElementId: 0 }],
            [CorrespondenceElementEnum.CONFIRMATORY_REQUEST,
            {
                resourceKey: 'easeportal.enum.CONFIRMATORY_REQUEST', dbElementKey: 25,
                replyResourceKey: 'easeportal.enum.REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL', replyDbElementId: 31
            }],
            [CorrespondenceElementEnum.ACKNOWLEDGEMENT_OF_RECEIPT_OF_THE_INITIAL_CONFIRMATORY_REPLY,
            {
                resourceKey: 'easeportal.enum.ACKNOWLEDGEMENT_OF_RECEIPT_OF_THE_INITIAL_CONFIRMATORY_REPLY', dbElementKey: 34,
                replyResourceKey: '', replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.UNILATERAL_RESTRICTION_OF_THE_SCOPE,
            {
                resourceKey: 'easeportal.enum.UNILATERAL_RESTRICTION_OF_THE_SCOPE', dbElementKey: 10,
                replyResourceKey: '', replyDbElementId: 0
            }],
            [CorrespondenceElementEnum.HOLDING_REPLY,
            {
                resourceKey: 'easeportal.enum.HOLDING_REPLY', dbElementKey: 14,
                replyResourceKey: '', replyDbElementId: 0
            }],
        ]);

    // Note: Without Array.from() the 'let ... of' loops cause: "type 'IterableIterator<>'
    // is not an array type or a string type" error when --downlevelIteration is not set
    // In any case here we do not stop to entries() IterableIterator.
    // We further map from [key: {resourceKey:  }] to {enumKey: , resourceKey:,  replyResourceKey: 'easeportal.enum.value' }
    export const entries: Array<Entry> = Array.from(fieldsMap.entries()).map((v) => ({ enumKey: v[0], ...v[1] }));
    // values of the enumerator
    export const values: Array<CorrespondenceElementEnum> = Array.from(fieldsMap.keys());

    export const resourceKey = (e: CorrespondenceElementEnum): string => {
        const x = fieldsMap.get(e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        } // strictNullChecks require this
        return x.resourceKey;
    };
    export const dbElementValue = (n: number): string => {
        const x = entries.find((y) => y.dbElementKey === n);
        if (x === undefined) {
            throw Error('Invalid element value');
        } // strictNullChecks require this
        return x.resourceKey;

    };
    export const dbElementKey = (n: number): string => {
        const x = entries.find((val) => val.dbElementKey === n);
        if (x === undefined) {
            throw Error('Invalid element value');
        } // strictNullChecks require this
        return x.enumKey;
    };
    export const replyResourceKey = (n: number): string => {
        const x = entries.find((val) => val.dbElementKey === n);
        if (x === undefined) {
            throw Error('Invalid element value');
        } // strictNullChecks require this
        return x.replyResourceKey;
    };
    export const getReplyElementId = (n: number): number => {
        const x = entries.find((val) => val.dbElementKey === n);
        if (x === undefined) {
            throw Error('Invalid element value');
        } // strictNullChecks require this
        return x.replyDbElementId;
    };
}

export { CorrespondenceElementEnum, };
